import { createFileRoute } from "@tanstack/react-router";

import { PatientSyncLibreviewSelectPage } from "@/uiKit/pages/PatientSyncLibreviewSelectPage.tsx";

export const Route = createFileRoute("/_practitioner/patient-sync/libreview-select")({
  component: PatientSyncLibreviewSelectPage,
});
